/* 
Author:Lamiaa Moustafa
Desc: Register component
*/

import React from 'react'
import {ProtectedBG} from "../../Styles/styledComponents/BgImage"
import { FormContainer } from '../../Styles/styledComponents/Form'
import { Outlet } from 'react-router-dom'

 const Home = () => {
  return (
    <>
    <ProtectedBG>
      <FormContainer>
         <Outlet/>
      </FormContainer>
    </ProtectedBG>
    </>
  )
}
export default Home;

// const FormContainer = styled.section`
//   width: 70%;
//   height: 70vh;
//   display: flex;
//   flex-direction:column;
//   justify-content: center;
//   align-items: center;
//   background-color:var(--white);
//   opacity:0.7;
// `;